import type { CSSProperties, ReactElement } from "react";
import { useAuth } from "./auth/useAuth";
import { rememberPostLoginPath } from "./auth/postLoginRedirect";

const APP_NAME = "Galileo · Office";

const shellStyle: CSSProperties = {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
};

const cardStyle: CSSProperties = {
    width: "100%",
    maxWidth: "440px",
    padding: "40px 32px",
    background: "rgba(255, 255, 255, 0.04)",
    border: "1px solid rgba(255, 255, 255, 0.12)",
    borderRadius: "20px",
    textAlign: "center",
    backdropFilter: "blur(8px)",
    WebkitBackdropFilter: "blur(8px)",
    boxShadow: "0 16px 48px rgba(0, 0, 0, 0.4)",
};

const titleStyle: CSSProperties = {
    margin: "0 0 8px",
    fontSize: "1.6rem",
    fontWeight: 700,
    letterSpacing: "-0.01em",
};

const subtitleStyle: CSSProperties = {
    margin: "0 0 32px",
    color: "rgba(255, 255, 255, 0.65)",
    fontSize: "0.95rem",
};

const buttonStyle: CSSProperties = {
    width: "100%",
    padding: "12px 20px",
    borderRadius: "10px",
    border: "1px solid rgba(255, 255, 255, 0.16)",
    background: "linear-gradient(135deg, oklch(0.70 0.165 250), oklch(0.55 0.165 268))",
    color: "white",
    fontSize: "1rem",
    fontWeight: 600,
    cursor: "pointer",
    transition: "transform 120ms ease",
};

/**
 * Unauthenticated landing screen. Single primary action: sign in via Entra.
 * Iteration-0 deliberately skips brand chrome and motion until the sign-in
 * round-trip is proven against the QA SPA registration.
 */
export function SignInGate(): ReactElement {
    const auth = useAuth();

    function handleSignIn(): void {
        rememberPostLoginPath();
        void auth.signIn();
    }

    return (
        <div style={shellStyle}>
            <div style={cardStyle}>
                <h1 style={titleStyle}>{APP_NAME}</h1>
                <p style={subtitleStyle}>
                    Sign in with your Sage Freight account to continue.
                </p>
                <button type="button" style={buttonStyle} onClick={handleSignIn}>
                    Sign in
                </button>
            </div>
        </div>
    );
}
